import { render, staticRenderFns } from "./BlocksDZ.vue?vue&type=template&id=e891508e&scoped=true"
import script from "./BlocksDZ.vue?vue&type=script&lang=js"
export * from "./BlocksDZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e891508e",
  null
  
)

export default component.exports